/** 游戏 ID，来源于 crawler/camp/manifest.json */
export const GAME_ID = 3203;

/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const TOOL_ID = "1t4dhjgk";

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType */
export const TOOL_TYPE = 5;
